/**
 * V2 Block Accordion Item — open/close toggle
 * Figma: block-accordion Item (96:67)
 *
 * Optional parent: [data-v2-accordion][data-v2-accordion-mode="single"|"multiple"]
 * Section can set mode later (one-at-a-time vs many open).
 */
(function () {
  const ITEM_SELECTOR = '[data-v2-accordion-item]';
  const ROOT_SELECTOR = '[data-v2-accordion]';

  function setOpen(item, open) {
    const trigger = item.querySelector('[data-v2-accordion-trigger]');
    const panel = item.querySelector('[data-v2-accordion-panel]');
    if (!trigger || !panel) return;

    item.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
  }

  function closeSiblings(item) {
    const root = item.closest(ROOT_SELECTOR);
    if (!root || root.getAttribute('data-v2-accordion-mode') !== 'single') return;

    root.querySelectorAll(`${ITEM_SELECTOR}.is-open`).forEach((other) => {
      if (other !== item) setOpen(other, false);
    });
  }

  /* Theme sets html { scroll-behavior: smooth } — that would animate any correction. */
  function instantScrollBy(dy) {
    const root = document.documentElement;
    const previous = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollBy(0, dy);
    root.style.scrollBehavior = previous;
  }

  /* Keep the clicked title at the same viewport Y. Content opens/closes below it.
     Do not scroll the row to the top of the page. */
  function keepTriggerInPlace(trigger, mutate) {
    const topBefore = trigger.getBoundingClientRect().top;
    mutate();

    const restore = () => {
      const delta = trigger.getBoundingClientRect().top - topBefore;
      if (Math.abs(delta) <= 1) return;
      instantScrollBy(delta);
    };

    restore();
    requestAnimationFrame(() => {
      restore();
      requestAnimationFrame(restore);
    });
  }

  function onTriggerClick(event) {
    const trigger = event.currentTarget;
    const item = trigger.closest(ITEM_SELECTOR);
    if (!item) return;

    const willOpen = !item.classList.contains('is-open');
    keepTriggerInPlace(trigger, () => {
      if (willOpen) closeSiblings(item);
      setOpen(item, willOpen);
    });
  }

  function bindItem(item) {
    if (!item || item.dataset.v2AccordionReady === 'true') return;
    const trigger = item.querySelector('[data-v2-accordion-trigger]');
    if (!trigger) return;

    item.dataset.v2AccordionReady = 'true';
    trigger.addEventListener('click', onTriggerClick);
  }

  function initAll(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll(ITEM_SELECTOR).forEach(bindItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
